import TypesenseInstantsearchAdapter from "typesense-instantsearch-adapter";
import {
  INSTANT_SEARCH_API_KEY,
  INSTANT_SEARCH_APP_ID,
  INSTANT_SEARCH_HOST,
  INSTANT_SEARCH_PATH,
  INSTANT_SEARCH_PORT,
  INSTANT_SEARCH_PRESET,
  INSTANT_SEARCH_PRESET_REGEX,
  INSTANT_SEARCH_PROTOCOL,
} from "./constants";

export const searchAdapter = new TypesenseInstantsearchAdapter({
  server: {
    apiKey: INSTANT_SEARCH_API_KEY, // Be sure to use the search-only-api-key
    nodes: [
      {
        host: INSTANT_SEARCH_HOST,
        port: INSTANT_SEARCH_PORT,
        protocol: INSTANT_SEARCH_PROTOCOL,
        path: INSTANT_SEARCH_PATH,
      }
    ]
  },
  collectionSpecificSearchParameters: {
    item_group: { preset: INSTANT_SEARCH_PRESET },
    item_group_query: { query_by: 'q' }
  },
  facetableFieldsWithSpecialCharacters: [
    "category.lvl1",
    "category.lvl2",
    "category.lvl3",
    "category.lvl4",
    "category.lvl5",
    "category.lvl6",
    "genre",
    "system",
  ],
  renderingContent: {
    facetOrdering: {
      facets: {
        order: [
          "is_sale",
          "min_price",
          "conditions",
          "availability",
          "system_manufacturer",
          "type",
          "genre",
          "color_groups",
          "is_graded",
          "is_ips",
          "is_import",
          "packaging",
          "versions",
          "languages",
          "usk",
          "category.lvl1",
          "category.lvl2",
          "category.lvl3",
          "category.lvl4",
          "category.lvl5",
          "category.lvl6",
        ]
      }
    },
  }
});

export const searchClient = searchAdapter.searchClient;
export const typesenseClient = searchAdapter.typesenseClient;

// Must be set in order for autocomplete suggestions to work
searchClient.transporter = {
  headers: {
    "x-algolia-application-id": INSTANT_SEARCH_APP_ID,
    "x-algolia-api-key": INSTANT_SEARCH_API_KEY,
  },
}

// Patch the multiSearch method to support presets in sort_by
const originalMultiSearch = typesenseClient.multiSearch.perform.bind(typesenseClient.multiSearch);
typesenseClient.multiSearch.perform = (searchRequests, commonParams, options) => {
  const patchedRequests = {
    ...searchRequests,
    searches: (searchRequests.searches || []).map((search) => {
      if (typeof search.sort_by === "string" && INSTANT_SEARCH_PRESET_REGEX.test(search.sort_by)) {
        const [, preset] = search.sort_by.match(INSTANT_SEARCH_PRESET_REGEX);
        const { sort_by, ...originalParams } = search;

        return { ...originalParams, preset };
      }
      return search;
    }),
  };

  return originalMultiSearch(patchedRequests, commonParams, options);
};
